import { render, staticRenderFns } from "./ClickableImagePlaceholder.vue?vue&type=template&id=65165476&scoped=true"
import script from "./ClickableImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./ClickableImagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ClickableImagePlaceholder.vue?vue&type=style&index=0&id=65165476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65165476",
  null
  
)

export default component.exports